<template>
    <v-dialog v-model="show" max-width="50%">
        <v-card >
          <v-card-title>
            <span class="text-h5">Add Mote</span>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="submitMote">
              <v-container>
                <v-row>
                  <v-col cols="12">
                      <v-text-field 
                      outlined hide-details 
                      label="Name"
                      v-model="moteName">
                      </v-text-field>
                  </v-col>
                  <v-col cols="12">
                      <v-text-field 
                      outlined hide-details 
                      label="UDID"
                      v-model="moteUdid">
                      </v-text-field>
                  </v-col>
                  <v-col cols="12">
                      <v-text-field 
                      outlined hide-details 
                      label="Type"
                      v-model="type">
                      </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  color="primary" @click="submitMote">Confirm</v-btn>
            <v-btn  @click="clearInput();show=false;">Cancel</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'AddMoteDialog',
    props:['visible','title'],
    data(){
        return {
            moteName:'',
            moteUdid:'',
            type:''
        }
    },
    methods:{
      clearInput(){
        this.moteName='';
        this.moteUdid='';
      },
      submitMote(){
        this.$emit('addMote',{EiName:this.moteName,DcUDID:this.moteUdid,EiType:this.type});
        this.clearInput();
        this.show=false;
      }
    },
    computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  watch:{
  }

}
</script>
